module.exports = __webpack_public_path__ + "img/238.38762f8b.jpg";